"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _debounce2 = _interopRequireDefault(require("lodash/debounce"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _clsx4 = _interopRequireDefault(require("clsx"));

var _commonTabs = require("@mmc/common-tabs");

var _commonDrawer = require("@mmc/common-drawer");

var _themeProvider = require("@mmc/theme-provider");

var _commonCta = require("@mmc/common-cta");

var _formElements = require("@mmc/form-elements");

var _useCountUp = require("use-count-up");

var _text = require("@mmc/text");

var _commonI18n = require("@mmc/common-i18n");

var _calculationForm = require("./calculation-form.utils");

var _paymentGraph = _interopRequireDefault(require("./payment-graph"));

var _extraLinks = _interopRequireDefault(require("./extra-links"));

var _calculatorOptionsForm = _interopRequireDefault(require("./calculator-options-form"));

var _calculatorOptionsBtn = _interopRequireDefault(require("./calculator-options-btn"));

var _calculatorCostBreakdownTable = _interopRequireDefault(require("./calculator-cost-breakdown-table"));

var _calculationForm2 = require("./calculation-form.prop-types");

var _calculatorForm = _interopRequireDefault(require("./calculator-form.css"));

require("./odometer.css");

var _constants = require("./constants");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _br;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString;

var getLinkData = function getLinkData(cta) {
  return {
    url: renderEmptyString(cta.url),
    label: renderEmptyString(cta.label),
    priority: renderEmptyString(cta.priority),
    openNewTab: renderEmptyString(cta.openNewTab)
  };
};

var Calculator = function Calculator(_ref) {
  var _clsx, _clsx2, _tabIndexMap$LEASE$ta, _annualMileageOptions, _annualMileageOptions2, _annualMileageOptions3, _clsx3, _leaseCalculation$tot, _dueOnDeliveryLease$t;

  var currencyFormat = _ref.currencyFormat,
      data = _ref.data,
      disclaimerData = _ref.disclaimerData,
      extraLinks = _ref.extraLinks,
      formData = _ref.formData,
      fullWidth = _ref.fullWidth,
      labels = _ref.labels,
      localeCode = _ref.localeCode,
      market = _ref.market,
      onFormChange = _ref.onFormChange,
      onTabChange = _ref.onTabChange,
      openShareDialog = _ref.openShareDialog,
      selectedTab = _ref.selectedTab,
      small = _ref.small,
      language = _ref.language,
      _ref$selectedModel = _ref.selectedModel,
      selectedModel = _ref$selectedModel === void 0 ? {} : _ref$selectedModel,
      isBackgroundWhite = _ref.isBackgroundWhite,
      inlineData = _ref.inlineData;
  var theme = (0, _themeProvider.useTheme)();

  var _useState = (0, _react.useState)(false),
      isCostsModalOpen = _useState[0],
      setCostsModalStatus = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isTaxesFeesModalOpen = _useState2[0],
      setTaxesFeesModalStatus = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      totalTaxesAndFeesSelected = _useState3[0],
      setTotalTaxesAndFeesSelected = _useState3[1];

  var toggleCostsModal = function toggleCostsModal() {
    return setCostsModalStatus(!isCostsModalOpen);
  };

  var toggleTaxesFeesModalStatus = function toggleTaxesFeesModalStatus() {
    return setTaxesFeesModalStatus(!isTaxesFeesModalOpen);
  };

  var _data$financeCalculat = data.financeCalculation,
      financeCalculation = _data$financeCalculat === void 0 ? {} : _data$financeCalculat,
      _data$leaseCalculatio = data.leaseCalculation,
      leaseCalculation = _data$leaseCalculatio === void 0 ? {} : _data$leaseCalculatio,
      _data$cashCalculation = data.cashCalculation,
      cashCalculation = _data$cashCalculation === void 0 ? {} : _data$cashCalculation,
      financeMonthlyPaymentDisclaimerId = data.financeMonthlyPaymentDisclaimerId,
      interestRateDisclaimerId = data.interestRateDisclaimerId,
      leaseMonthlyPaymentDisclaimerId = data.leaseMonthlyPaymentDisclaimerId,
      dueAtLeaseSigningDisclaimerId = data.dueAtLeaseSigningDisclaimerId,
      annualMileageDisclaimerId = data.annualMileageDisclaimerId,
      cashMonthlyPaymentDisclaimerId = data.cashMonthlyPaymentDisclaimerId,
      monthSuffixLabel = data.monthSuffixLabel,
      vehicles = data.vehicles,
      financeSelectedPaymentFrequency = data.financeSelectedPaymentFrequency,
      financePaymentFrequency = data.financePaymentFrequency,
      leaseSelectedPaymentFrequency = data.leaseSelectedPaymentFrequency,
      leasePaymentFrequency = data.leasePaymentFrequency;

  var _inlineData = _objectSpread({}, inlineData),
      additionalCtas = _inlineData.additionalCtas;

  var isFR = language === 'fr';
  var debouncedOnFormChange = (0, _debounce2["default"])(onFormChange, 500);

  var ensureDownPaymentUnderTotal = function ensureDownPaymentUnderTotal(value) {
    var msrpValue = vehicles[0].msrpValue;
    var inputVal = value;

    if (value >= msrpValue) {
      inputVal = msrpValue - 1;
    }

    return inputVal;
  };

  var handleInputNumberChange = function handleInputNumberChange(e) {
    var value = +e.target.value;

    if (!Number.isNaN(value)) {
      var _objectSpread2;

      var name = e.target.name;

      if (name === 'leaseDownPayment' || name === 'financeDownPayment' || name === 'leaseTradeInValue' || name === 'financeTradeInValue' || name === 'cashTradeInValue') {
        value = ensureDownPaymentUnderTotal(value);
      }

      debouncedOnFormChange(_objectSpread(_objectSpread({}, formData), {}, (_objectSpread2 = {}, _objectSpread2[name] = value, _objectSpread2)), name, value);
    }
  };

  var handleInputSelectChange = function handleInputSelectChange(e) {
    var _objectSpread3;

    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    onFormChange(_objectSpread(_objectSpread({}, formData), {}, (_objectSpread3 = {}, _objectSpread3[name] = value, _objectSpread3)), name, value);
  };

  var getTotalRightLabel = function getTotalRightLabel(options, value) {
    if (!value) return '';
    var selectedOption = options.find(function (option) {
      return option.value === value;
    });
    return selectedOption.label;
  };

  var handleTabsChange = function handleTabsChange(_ref2) {
    var _objectSpread4;

    var name = _ref2.name,
        value = _ref2.value;
    onFormChange(_objectSpread(_objectSpread({}, formData), {}, (_objectSpread4 = {}, _objectSpread4[name] = value, _objectSpread4)), name, value);
  };

  var toggleCustomRate = function toggleCustomRate() {
    onFormChange(_objectSpread(_objectSpread({}, formData), {}, {
      isDefaultRate: !formData.isDefaultRate
    }), 'isDefaultRate', !formData.isDefaultRate);
  };

  var formatCurrency = (0, _react.useCallback)(function (value, digits) {
    if (digits === void 0) {
      digits = 2;
    }

    return (0, _calculationForm.formatPrice)(value, currencyFormat, localeCode, digits);
  }, []);
  var formatPercentage = (0, _react.useCallback)(function (value, minDecimal, maxDecimal) {
    if (minDecimal === void 0) {
      minDecimal = 0;
    }

    if (maxDecimal === void 0) {
      maxDecimal = 2;
    }

    return (0, _calculationForm.formatPercent)(value, localeCode, minDecimal, maxDecimal);
  }, []); // FIXME: Find `amountFinanced` value
  // const isOverMinimumLoan =
  //   get(financeCalculation, 'amountFinanced.value', 0) >
  //   Number(data.minimumLoanAllowance);

  var isOverMinimumLoan = true;
  var calculatorOptionsLabel = labels.taxeFeesHeading + " (" + totalTaxesAndFeesSelected + ")";
  var tabDescriptionClassName = (0, _clsx4["default"])(_calculatorForm["default"].tabDescription, (_clsx = {}, _clsx[_calculatorForm["default"].smallText] = small, _clsx));
  var tabTitleClassName = (0, _clsx4["default"])(_calculatorForm["default"].tabTitle, (_clsx2 = {}, _clsx2[_calculatorForm["default"].smallText] = small, _clsx2));
  var selectedCalculation = (_tabIndexMap$LEASE$ta = {}, _tabIndexMap$LEASE$ta[_constants.tabIndexMap.LEASE] = leaseCalculation, _tabIndexMap$LEASE$ta[_constants.tabIndexMap.FINANCE] = financeCalculation, _tabIndexMap$LEASE$ta[_constants.tabIndexMap.CASH] = cashCalculation, _tabIndexMap$LEASE$ta)[selectedTab];
  var extraLinksProps = {
    data: _objectSpread(_objectSpread({}, data), extraLinks),
    onShareDialogClick: openShareDialog,
    onCostsOrTaxesModalClick: toggleCostsModal,
    calculation: selectedCalculation,
    market: market,
    labels: labels
  };

  var updateTotalTaxesAndRebates = function updateTotalTaxesAndRebates(selection) {
    var totalSelection = (0, _calculationForm.getTotalTaxesAndFeesSelectedByCalculation)(selection, selectedCalculation);
    setTotalTaxesAndFeesSelected(totalSelection);
  };

  var handleCalculationOptionsSubmit = function handleCalculationOptionsSubmit(selection) {
    updateTotalTaxesAndRebates(selection); // Update each individual field in the selection

    Object.entries(selection).forEach(function (_ref3) {
      var _objectSpread5;

      var key = _ref3[0],
          value = _ref3[1];
      onFormChange(_objectSpread(_objectSpread({}, formData), {}, (_objectSpread5 = {}, _objectSpread5[key] = value, _objectSpread5)), key, value);
    });
    toggleTaxesFeesModalStatus();
  };

  (0, _react.useEffect)(function () {
    updateTotalTaxesAndRebates(formData);
  }, [selectedTab]);
  var annualMileageOptionsLease = leaseCalculation.terms.find(function (term) {
    return term.value === (formData.leaseTerm || (0, _calculationForm.getDefaultValue)(leaseCalculation.terms));
  });
  var selectedMileageLease = formData.leaseAnnualMileage || (annualMileageOptionsLease == null ? void 0 : (_annualMileageOptions = annualMileageOptionsLease.listPaymentResidualMileage) == null ? void 0 : (_annualMileageOptions2 = _annualMileageOptions[0]) == null ? void 0 : _annualMileageOptions2.mileage);
  var dueOnDeliveryLease = (annualMileageOptionsLease == null ? void 0 : (_annualMileageOptions3 = annualMileageOptionsLease.listPaymentResidualMileage) == null ? void 0 : _annualMileageOptions3.length) && annualMileageOptionsLease.listPaymentResidualMileage.find(function (opt) {
    return opt.mileage === selectedMileageLease;
  });

  var renderAdditionalCtas = function renderAdditionalCtas(additionalCtas) {
    if (additionalCtas && additionalCtas.length > 0) {
      return additionalCtas.map(function (cta, i) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _calculatorForm["default"].additionalCta
        }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
          theme: theme,
          data: getLinkData(cta)
        }));
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])((_clsx3 = {}, _clsx3[_calculatorForm["default"].calculatorForm] = true, _clsx3[_calculatorForm["default"].small] = small, _clsx3))
  }, /*#__PURE__*/_react["default"].createElement(_commonDrawer.CommonDrawer, {
    visible: isTaxesFeesModalOpen,
    onClose: toggleTaxesFeesModalStatus,
    contentClassName: _calculatorForm["default"].drawer,
    isPopover: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme['col-xs-12'], theme['col-sm-8'], theme['col-sm-offset-1'])
  }, isTaxesFeesModalOpen && /*#__PURE__*/_react["default"].createElement(_calculatorOptionsForm["default"], {
    labels: labels,
    calculation: selectedCalculation,
    formData: formData,
    onSubmit: handleCalculationOptionsSubmit
  }))), /*#__PURE__*/_react["default"].createElement(_commonDrawer.CommonDrawer, {
    visible: isCostsModalOpen,
    onClose: toggleCostsModal,
    prerender: true,
    contentClassName: _calculatorForm["default"].drawer,
    isPopover: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme['col-xs-12'], theme['col-md-12'])
  }, /*#__PURE__*/_react["default"].createElement(_calculatorCostBreakdownTable["default"], {
    onClose: toggleCostsModal,
    labels: labels,
    calculation: selectedCalculation
  }))), /*#__PURE__*/_react["default"].createElement(_commonTabs.CommonRoleTab, {
    onTabChange: onTabChange,
    theme: theme,
    tabListClasses: _calculatorForm["default"].tabList,
    ctaWrapperClasses: _calculatorForm["default"].tabCta,
    variant: isBackgroundWhite ? 'lightWithoutBorder' : 'dark',
    disclaimerData: disclaimerData,
    fullWidth: fullWidth,
    selectedTab: selectedTab,
    tabNames: [/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: tabTitleClassName
    }, labels.leaseTabLabel), /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculatorForm["default"].tabAmount
    }, /*#__PURE__*/_react["default"].createElement(_useCountUp.CountUp, {
      isCounting: true,
      end: leaseCalculation.monthlyPaymentValue,
      duration: 1
    }, function (_ref4) {
      var value = _ref4.value;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _calculatorForm["default"].paymentAmount
      }, formatCurrency(value, small ? 0 : undefined));
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: _calculatorForm["default"].tabDescription
    }, (0, _calculationForm.getSelectedPaymentFrequencyLabel)(leaseSelectedPaymentFrequency, leasePaymentFrequency), !small && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, leaseCalculation.monthlyDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, leaseCalculation.monthlyDisclaimerNo), leaseMonthlyPaymentDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: "#" + leaseMonthlyPaymentDisclaimerId + "#",
      disclaimerData: data.disclaimerData,
      tag: "span",
      className: (0, _clsx4["default"])(_calculatorForm["default"].disclaimer, _calculatorForm["default"].darkGreyDisclaimer)
    })))), small && /*#__PURE__*/_react["default"].createElement("p", {
      className: tabDescriptionClassName
    }, monthSuffixLabel)), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: tabTitleClassName
    }, labels.buyTabLabel), /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculatorForm["default"].tabAmount
    }, /*#__PURE__*/_react["default"].createElement(_useCountUp.CountUp, {
      isCounting: true,
      end: financeCalculation.monthlyPaymentValue,
      duration: 1
    }, function (_ref5) {
      var value = _ref5.value;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _calculatorForm["default"].paymentAmount
      }, formatCurrency(value, small ? 0 : undefined));
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: _calculatorForm["default"].tabDescription
    }, (0, _calculationForm.getSelectedPaymentFrequencyLabel)(financeSelectedPaymentFrequency, financePaymentFrequency), !small && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, financeCalculation.monthlyDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, financeCalculation.monthlyDisclaimerNo), financeMonthlyPaymentDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: "#" + financeMonthlyPaymentDisclaimerId + "#",
      disclaimerData: data.disclaimerData,
      tag: "span",
      className: (0, _clsx4["default"])(_calculatorForm["default"].disclaimer, _calculatorForm["default"].darkGreyDisclaimer)
    })))), small && isOverMinimumLoan && /*#__PURE__*/_react["default"].createElement("p", {
      className: tabDescriptionClassName
    }, monthSuffixLabel)), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: tabTitleClassName
    }, labels.cashTabLabel), /*#__PURE__*/_react["default"].createElement("div", {
      className: _calculatorForm["default"].tabAmount
    }, /*#__PURE__*/_react["default"].createElement(_useCountUp.CountUp, {
      isCounting: true,
      end: cashCalculation.paymentAmount.value,
      duration: 1
    }, function (_ref6) {
      var value = _ref6.value;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: _calculatorForm["default"].paymentAmount
      }, formatCurrency(value, small ? 0 : undefined));
    }), !small && /*#__PURE__*/_react["default"].createElement("span", {
      className: _calculatorForm["default"].tabDescription
    }, cashCalculation.monthlyDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, cashCalculation.monthlyDisclaimerNo), cashMonthlyPaymentDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: "#" + cashMonthlyPaymentDisclaimerId + "#",
      disclaimerData: data.disclaimerData,
      tag: "span",
      className: (0, _clsx4["default"])(_calculatorForm["default"].disclaimer, _calculatorForm["default"].darkGreyDisclaimer)
    }))))]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].form
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].formInner
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement(_calculatorOptionsBtn["default"], {
    label: calculatorOptionsLabel,
    onOpen: toggleTaxesFeesModalStatus
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-6']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    key: formData.leaseDownPayment,
    name: "leaseDownPayment",
    label: labels.downPaymentLabel,
    onChange: handleInputNumberChange,
    formatValue: formatCurrency,
    defaultValue: formData.leaseDownPayment,
    validation: {
      pattern: {
        value: labels.regexRestrictDecimalPricing,
        message: labels.errorMessageDownPaymentAndTradeIn
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-6']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    key: formData.leaseTradeInValue,
    name: "leaseTradeInValue",
    label: labels.tradeInValueLabel,
    onChange: handleInputNumberChange,
    formatValue: formatCurrency,
    defaultValue: formData.leaseTradeInValue,
    validation: {
      pattern: {
        value: labels.regexRestrictDecimalPricing,
        message: labels.errorMessageDownPaymentAndTradeIn
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, labels.annualMileageLabel && /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.annualMileageLabel, annualMileageDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: "#" + annualMileageDisclaimerId + "#",
    disclaimerData: data.disclaimerData,
    tag: "span",
    className: _calculatorForm["default"].mileageDisclaimer
  })), data.leaseAnnualMileageOptions && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
    name: "leaseAnnualMileage",
    onChange: handleTabsChange,
    tabs: data.leaseAnnualMileageOptions,
    className: theme.mb10
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.termsLabel), data.leaseTerms && /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
    name: "leaseTerm",
    onChange: handleTabsChange,
    tabs: data.leaseTerms,
    className: theme.mb10
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme.row, theme.mb10)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-6']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Select, {
    label: isFR ? 'FRÉQUENCE DE PAIEMENT' : 'Payment frequency',
    name: "leasePaymentFrequency",
    onChange: handleInputSelectChange,
    defaultValue: formData.leasePaymentFrequency,
    options: data.leasePaymentFrequency
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-6']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.interestLabel), /*#__PURE__*/_react["default"].createElement("p", {
    className: _calculatorForm["default"].defaultRateLabel
  }, data.leaseDefaultRate, " APR"))), extraLinks && /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['hidden-sm-down']
  }, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], extraLinksProps))), /*#__PURE__*/_react["default"].createElement("p", {
    className: _calculatorForm["default"].totalDescription
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].totalDownPayment
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      displayValue: formatCurrency(leaseCalculation == null ? void 0 : (_leaseCalculation$tot = leaseCalculation.totalDueOnDelivery) == null ? void 0 : _leaseCalculation$tot.value)
    },
    addPriceDisclaimer: data.addPriceDisclaimer,
    priceDisclaimerId: data.priceDisclaimerId,
    disclaimerData: data.disclaimerData
  })), /*#__PURE__*/_react["default"].createElement("span", null, labels.dueLeasingLabel, ' ', leaseCalculation.leaseSigningDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", {
    className: _calculatorForm["default"].sup
  }, leaseCalculation.leaseSigningDisclaimerNo)), /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].spanBlock
  }, labels.dueLeasingInclusionText), formData.includeTax && /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].spanBlock
  }, labels.includesSalesTaxLabel), extraLinks && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme['hidden-sm-up'], theme.mt10)
  }, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], extraLinksProps))))), !small && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paymentGraph["default"], {
    className: _calculatorForm["default"].paymentGraph,
    imagePath: selectedModel.imagePath,
    imageAltText: selectedModel.imageAltText,
    percentage: leaseCalculation.downPayment.value / leaseCalculation.totalSellingPrice.value * 100,
    totalLeft: formatCurrency(dueOnDeliveryLease == null ? void 0 : (_dueOnDeliveryLease$t = dueOnDeliveryLease.totalDueOnDelivery) == null ? void 0 : _dueOnDeliveryLease$t.value),
    totalLeftLabel: data.totalDueOnDeliveryLabel,
    totalRight: formatCurrency(leaseCalculation.monthlyPaymentValue),
    totalRightLabel: getTotalRightLabel(data.leasePaymentFrequency, formData.leasePaymentFrequency),
    leaseSigningDisclaimerNo: leaseCalculation.leaseSigningDisclaimerNo,
    dueAtLeaseSigningDisclaimerId: dueAtLeaseSigningDisclaimerId,
    disclaimerData: data.disclaimerData,
    includeTax: formData.includeTax,
    includesSalesTaxLabel: labels.includesSalesTaxLabel
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].form
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].formInner
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement(_calculatorOptionsBtn["default"], {
    label: calculatorOptionsLabel,
    onOpen: toggleTaxesFeesModalStatus
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-6']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    key: formData.financeDownPayment,
    name: "financeDownPayment",
    label: labels.downPaymentLabel,
    onChange: handleInputNumberChange,
    formatValue: formatCurrency,
    defaultValue: formData.financeDownPayment,
    validation: {
      pattern: {
        value: labels.regexRestrictDecimalPricing,
        message: labels.errorMessageDownPaymentAndTradeIn
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-6']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    key: formData.financeTradeInValue,
    name: "financeTradeInValue",
    label: labels.tradeInValueLabel,
    onChange: handleInputNumberChange,
    formatValue: formatCurrency,
    defaultValue: formData.financeTradeInValue,
    validation: {
      pattern: {
        value: labels.regexRestrictDecimalPricing,
        message: labels.errorMessageDownPaymentAndTradeIn
      }
    }
  }))), data.financeTerms && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme.row, theme.mb10)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.termsLabel), /*#__PURE__*/_react["default"].createElement(_formElements.TabButtonGroup, {
    name: "financeTerm",
    onChange: handleTabsChange,
    tabs: data.financeTerms
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme.row, theme.mb10)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme['col-xs-12'], theme['col-md-6'])
  }, /*#__PURE__*/_react["default"].createElement(_formElements.LabelLike, null, labels.interestLabel, financeCalculation.interestRateDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", null, financeCalculation.interestRateDisclaimerNo), interestRateDisclaimerId && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: "#" + interestRateDisclaimerId + "#",
    disclaimerData: data.disclaimerData,
    tag: "span",
    className: (0, _clsx4["default"])(_calculatorForm["default"].disclaimer, _calculatorForm["default"].smallDisclaimer, _calculatorForm["default"].darkGreyDisclaimer)
  })), formData.isDefaultRate ? /*#__PURE__*/_react["default"].createElement("p", {
    className: _calculatorForm["default"].defaultRateLabel
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].badge
  }, "Offer"), ' ', data.financeDefaultRate.displayValue, " APR") : /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    name: "interestRate",
    onChange: handleInputNumberChange,
    formatValue: formatPercentage,
    defaultValue: data.financeDefaultRate.value,
    validation: {
      pattern: {
        value: labels.regexRestrictDecimalPricing,
        message: financeCalculation.validationRateErrorMsg
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme['col-xs-12'], theme['col-md-6'], _calculatorForm["default"].defaultRateBtn)
  }, formData.isDefaultRate ? /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    classes: [_calculatorForm["default"].ctaBtn],
    clickEvent: toggleCustomRate,
    data: {
      priority: 'trivial',
      label: labels.customRateLabel
    }
  }) : /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    classes: [_calculatorForm["default"].ctaBtn],
    clickEvent: toggleCustomRate,
    data: {
      priority: 'trivial',
      label: labels.defaultRateLabel
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme.row, theme.mb10)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Select, {
    label: isFR ? 'FRÉQUENCE DE PAIEMENT' : 'Payment frequency',
    name: "financePaymentFrequency",
    onChange: handleInputSelectChange,
    defaultValue: formData.financePaymentFrequency,
    options: data.financePaymentFrequency
  }))), extraLinks && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], extraLinksProps))), /*#__PURE__*/_react["default"].createElement("p", {
    className: _calculatorForm["default"].totalDescription
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].totalDownPayment
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      displayValue: formatCurrency(financeCalculation.downPayment.value)
    },
    addPriceDisclaimer: data.addPriceDisclaimer,
    priceDisclaimerId: data.priceDisclaimerId,
    disclaimerData: data.disclaimerData
  })), labels.downPaymentLabel, _br || (_br = /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      displayValue: formatCurrency((0, _get2["default"])(financeCalculation, 'amountFinanced.value'))
    },
    addPriceDisclaimer: data.addPriceDisclaimer,
    priceDisclaimerId: data.priceDisclaimerId,
    disclaimerData: data.disclaimerData
  }), ' ', labels.amountFinancedLabel, ".", ' ', labels.amountFinancedInclusionText, ".", formData.includeTax && /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].spanBlock
  }, labels.includesSalesTaxLabel)))), !small && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paymentGraph["default"], {
    className: _calculatorForm["default"].paymentGraph,
    imagePath: selectedModel.imagePath,
    imageAltText: selectedModel.imageAltText,
    percentage: financeCalculation.downPayment.value / financeCalculation.totalSellingPrice.value * 100,
    totalLeft: formatCurrency(financeCalculation.totalDueOnDelivery.value),
    totalLeftLabel: data.totalDueOnDeliveryLabel,
    totalRight: formatCurrency(financeCalculation.monthlyPaymentValue),
    totalRightLabel: getTotalRightLabel(data.financePaymentFrequency, formData.financePaymentFrequency),
    includeTax: formData.includeTax,
    includesSalesTaxLabel: labels.includesSalesTaxLabel
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].form
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].formInner
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement(_calculatorOptionsBtn["default"], {
    label: calculatorOptionsLabel,
    onOpen: toggleTaxesFeesModalStatus
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12']
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: _calculatorForm["default"].defaultRateLabel
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].badge
  }, cashCalculation.cashOfferLabel), cashCalculation.includeDiscountLabel)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(theme['col-xs-12'], theme['col-md-6'])
  }, /*#__PURE__*/_react["default"].createElement(_formElements.Input, {
    key: formData.cashTradeInValue,
    name: "cashTradeInValue",
    label: labels.tradeInValueLabel,
    onChange: handleInputNumberChange,
    formatValue: formatCurrency,
    defaultValue: formData.cashTradeInValue,
    className: theme.mb10,
    validation: {
      pattern: {
        value: labels.regexRestrictDecimalPricing,
        message: labels.errorMessageDownPaymentAndTradeIn
      }
    }
  }))), extraLinks && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_extraLinks["default"], extraLinksProps))), /*#__PURE__*/_react["default"].createElement("p", {
    className: _calculatorForm["default"].totalDescription
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].totalDownPayment
  }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
    format: "price",
    options: {
      displayValue: formatCurrency(cashCalculation.paymentAmount.value)
    },
    addPriceDisclaimer: data.addPriceDisclaimer,
    priceDisclaimerId: data.priceDisclaimerId,
    disclaimerData: data.disclaimerData
  })), /*#__PURE__*/_react["default"].createElement("span", null, labels.dueCashLabel, ' ', cashCalculation.cashSigningDisclaimerNo && /*#__PURE__*/_react["default"].createElement("sup", {
    className: _calculatorForm["default"].sup
  }, cashCalculation.cashSigningDisclaimerNo)), formData.includeTax && /*#__PURE__*/_react["default"].createElement("span", {
    className: _calculatorForm["default"].spanBlock
  }, labels.includesSalesTaxLabel)))), !small && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_paymentGraph["default"], {
    className: _calculatorForm["default"].paymentGraph,
    imagePath: selectedModel.imagePath,
    imageAltText: selectedModel.imageAltText,
    percentage: 50,
    totalLeft: formatCurrency(cashCalculation.paymentAmount.value),
    totalLeftLabel: data.totalDueOnDeliveryLabel,
    includeTax: formData.includeTax,
    includesSalesTaxLabel: labels.includesSalesTaxLabel
  }))))), additionalCtas && additionalCtas.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].additionalCtaSection
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorForm["default"].additionalCtaWrapper
  }, renderAdditionalCtas(additionalCtas))));
};

var _default = Calculator;
exports["default"] = _default;